const membershipPartNumbers = ['CPPM', 'Membership-Annual', 'Membership-Monthly'];
const isMembershipSku = (sku) => {
    return membershipPartNumbers.includes(sku);
}

export default isMembershipSku;